import { connect } from 'react-redux';
import UpdatableEntryItem from 'containers/UpdatableEntryItem';
import { isEntrySelected } from '../selectors';
import { entriesOpened } from '../actions';

const mapStateToProps = ({ scene }, ownProps) => {
  return {
    ...ownProps,
    isSelected: isEntrySelected({ scene }, ownProps)
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    handleOpened: (id) => { dispatch(entriesOpened([ id ], 'entry item')) }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(UpdatableEntryItem);



// WEBPACK FOOTER //
// ./src/scenes/Main/components/MainEntryItem.js